import { render, staticRenderFns } from "./ProposalButton.vue?vue&type=template&id=381a414c"
import script from "./ProposalButton.vue?vue&type=script&lang=js"
export * from "./ProposalButton.vue?vue&type=script&lang=js"
import style0 from "./ProposalButton.vue?vue&type=style&index=0&id=381a414c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports